import React from "react";
import styled from "styled-components/macro";
import * as Yup from "yup";
import axios from "../../CustomAxios";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function ResetPassword({
  setMailSubmitted,
  userType,
  setEmail,
  setToken,
  loading,
  setLoading,
}) {
  const [err, setErr] = React.useState("");

  const resetPassword = async (email) => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        `/api/v1/${userType}/reset_password/create`,
        {
          email_address: email,
        }
      );
      if (data.success) {
        setEmail(email);
        setToken(data.verification_key);
        setMailSubmitted(true);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
    }
  };

  return (
    <Formik
      initialValues={{
        email: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          resetPassword(values.email);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {err ? (
            <Alert mt={2} mb={3} severity="error">
              {err}
            </Alert>
          ) : null}

          <TextField
            type="email"
            name="email"
            label="Email Address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting || loading}
          >
            {loading ? "Sending OTP..." : "Reset password"}
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default ResetPassword;
